// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {

    .scl--cnt-sty-head-box {
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
        position: relative;
        justify-content: space-between;
    }

    .scl--hdd-cont-stl-bo .scl--dd-hea-box-cont-stlr{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--style-contact-button {
        width: 91px;
        height: 26px;
    }

    .scl--style-contact-button span {
        font-size: var(--font-size-sssm);
    }

    .scl--style-logo-text {
        font-size: 30px;
    }

    .scl--resp-hea-ext-btn-stl{
        display: flex;
        gap: 12px;
    }

    .scl--wpcops-bo-cont-str-compl{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--wpds-resp-con-stl{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--wtcs-ti-con-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--step-comp-box-cont-stl{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }

    .scl--step-comp-box-cont-stl .scl--web-component-talent-description{
        width: 100%;
        line-height: 30px;
    }

    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str p{
        line-height: 40px;
    }

    .scl--hdd-cont-stl-bo{
        top: 86px;
    }

    .scl--style-logo-link img{
        width: 133px;
    }
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/header/css/headerSm.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,+CAA+C;QAC/C,iDAAiD;QACjD,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@media (max-width: 500px) {\n\n    .scl--cnt-sty-head-box {\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n        position: relative;\n        justify-content: space-between;\n    }\n\n    .scl--hdd-cont-stl-bo .scl--dd-hea-box-cont-stlr{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--style-contact-button {\n        width: 91px;\n        height: 26px;\n    }\n\n    .scl--style-contact-button span {\n        font-size: var(--font-size-sssm);\n    }\n\n    .scl--style-logo-text {\n        font-size: 30px;\n    }\n\n    .scl--resp-hea-ext-btn-stl{\n        display: flex;\n        gap: 12px;\n    }\n\n    .scl--wpcops-bo-cont-str-compl{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--wpds-resp-con-stl{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--wtcs-ti-con-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--step-comp-box-cont-stl{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n\n    .scl--step-comp-box-cont-stl .scl--web-component-talent-description{\n        width: 100%;\n        line-height: 30px;\n    }\n\n    .scl--wdacs-bo-car-con-st .scl--dcbs-con-met-st-str p{\n        line-height: 40px;\n    }\n\n    .scl--hdd-cont-stl-bo{\n        top: 86px;\n    }\n\n    .scl--style-logo-link img{\n        width: 133px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
